import React from 'react';
import { Text, TextProps } from '@chakra-ui/react';

/** Renders error text under form inputs */
export function ErrorText({ children, ...textProps }: TextProps) {
  return (
    <Text color="red.500" fontSize="sm" mt={1} textAlign="right" {...textProps}>
      {children}
    </Text>
  );
}
